/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1SsoimageIdStatus200,
  PatchApiV1SsoimageIdStatus400,
  PatchApiV1SsoimageIdStatus401,
  PatchApiV1SsoimageIdStatus500,
  PatchApiV1SsoimageIdStatusMutationRequest,
  PatchApiV1SsoimageIdStatusMutationResponse,
  PatchApiV1SsoimageIdStatusPathParams,
} from "../../types/SSOImageController/PatchApiV1SsoimageIdStatus.ts";
import { updateSSOImageStatusViewModelSchema } from "../updateSSOImageStatusViewModelSchema.ts";

export const patchApiV1SsoimageIdStatusPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PatchApiV1SsoimageIdStatusPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const patchApiV1SsoimageIdStatus200Schema =
  z.any() as unknown as ToZod<PatchApiV1SsoimageIdStatus200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const patchApiV1SsoimageIdStatus400Schema =
  z.any() as unknown as ToZod<PatchApiV1SsoimageIdStatus400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1SsoimageIdStatus401Schema =
  z.any() as unknown as ToZod<PatchApiV1SsoimageIdStatus401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const patchApiV1SsoimageIdStatus500Schema =
  z.any() as unknown as ToZod<PatchApiV1SsoimageIdStatus500>;

export const patchApiV1SsoimageIdStatusMutationRequestSchema = z.lazy(
  () => updateSSOImageStatusViewModelSchema,
) as unknown as ToZod<PatchApiV1SsoimageIdStatusMutationRequest>;

export const patchApiV1SsoimageIdStatusMutationResponseSchema = z.lazy(
  () => patchApiV1SsoimageIdStatus200Schema,
) as unknown as ToZod<PatchApiV1SsoimageIdStatusMutationResponse>;
